<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "callseats",
      key: "id",
      ll: [],
      url: {
        get: "/admin/system/user/getUserInfo",
        add: "/admin/system/user/changeCall",
      },
      items: [
        { label: "来电坐席", desc: "修改来电弹屏坐席", type: "header" },
        {
          label: "来电坐席",
          name: "channelIds",
          value: [],
          multiple: "multiple",
          dropList: [
            { value: 2, name: "一号坐席" },
            { value: 3, name: "二号坐席" },
            { value: 0, name: "三号坐席" },
            { value: 1, name: "四号坐席" },
          ],
          type: "select",
          width: "400px",
        },
      ],
      forms: {
        channelIds: [],
      },
    };
  },
  computed: {},
  created() {
    this.getUserInfo();
  },
  methods: {
    async getUserInfo() {
      // 加载详情数据
      let res = await $utils.api.load(`/admin/system/user/getUserInfo`, {}, "GET");
      if (res && res.data) {
        this.forms.channelIds = res.data.channelIds;
      }
    },
  },
};
</script>
